import { disableFormActionButtons } from './disableFormActionButtons';

export type IValidateReCaptchaFields = (
  value: any,
  input: HTMLElement,
  initOnly?: boolean
) => Promise<boolean | null>;

function validateReCaptcha(
  $input: JQuery,
  tokenResolve: (value: string) => void,
  initOnly?: boolean
) {
  const $fieldHolder = $input.closest('.field-holder');
  const $div = $fieldHolder.find('.g-recaptcha.g-recaptcha-invisible').first();
  const sitekey = $div.data('sitekey');
  const isInitialized = $input.hasClass('was-initialized');

  // Temp disable form action buttons while waiting recaptcha response
  disableFormActionButtons($input);

  const expiredCallback = function () {
    window.grecaptcha.reset();
    $input.val('');
    $input.trigger('change');
    // @ts-ignore
    window.grecaptcha.execute().then(() => {
      const tokenResponse = grecaptcha.getResponse();
      if (tokenResponse) {
        successCallback(tokenResponse);
      } else {
        grecaptcha.execute();
      }
    });
  };

  const successCallback = function (token: string) {
    console.info('reCaptcha Succeeded!');
    $input.val(token);
    $input.trigger('change');
    $input.valid();
    if (typeof tokenResolve === 'function') {
      tokenResolve(token);
    }
    disableFormActionButtons($input, false);
  };

  if (!isInitialized) {
    $input.addClass('was-initialized');
    window.grecaptcha.ready(() => {
      window.grecaptcha.render($div.get(0), {
        'expired-callback': expiredCallback,
        callback: successCallback,
        sitekey,
      });
      grecaptcha.execute();
    });
  } else {
    const tokenResponse = grecaptcha.getResponse();
    if (tokenResponse) {
      successCallback(tokenResponse);
    } else {
      grecaptcha.execute();
    }
  }
}

export async function _validateReCaptchaFields(
  value: any,
  input: HTMLElement,
  initOnly?: boolean
): Promise<boolean | null> {
  if (!input) return null;

  let valid = false;

  const $input = $(input);

  let tokenResolve: (value: string | PromiseLike<string>) => void;

  const tokenPromise = new Promise<string>((_res) => {
    tokenResolve = _res;
  });

  // @ts-ignore
  validateReCaptcha($input, tokenResolve, initOnly);

  const token = await tokenPromise;

  if (token) {
    $input.val(token);
    $input.trigger('change');
    if (!initOnly) {
      $input.valid();
    }
    valid = true;
  }

  return valid;
}
